module.exports = __webpack_public_path__ + "static/blue-black-pattern-23c5a4bd0de6f0baae0a9f4e91aeae5d.svg";